import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { openCommandGlobal } from '../context/CommandContext';

import {
  CaretDown
} from '@phosphor-icons/react';
const DropdownMenu = ({ title, items, icon: Icon }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-4 py-2 text-white hover:text-[#14F195] transition-colors"
      >
        {Icon && <Icon size={18} />}
        <span className="font-medium">{title}</span>
        <CaretDown
          size={16}
          className={`transition-transform ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.2 }}
            className="absolute top-full left-0 mt-2 w-56 glass rounded-2xl border border-[rgba(255,255,255,0.1)] shadow-2xl overflow-hidden z-50"
          >
            {items.map((item, index) => 
              item.action === 'open_command' ? (
                <div
                  key={index}
                  onClick={() => { openCommandGlobal(); setIsOpen(false); }}
                  className="flex items-center gap-3 px-4 py-3 text-[#A0AEC0] hover:bg-[rgba(255,255,255,0.1)] hover:text-white transition-all border-b border-[rgba(255,255,255,0.05)] last:border-0 cursor-pointer"
                >
                  {item.icon && <item.icon size={18} />}
                  <span className="text-sm font-medium">{item.name}</span>
                </div>
              ) : (
              <Link
                key={index}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className="flex items-center gap-3 px-4 py-3 text-[#A0AEC0] hover:bg-[rgba(255,255,255,0.1)] hover:text-white transition-all border-b border-[rgba(255,255,255,0.05)] last:border-0"
              >
                {item.icon && <item.icon size={18} />}
                <span className="text-sm font-medium">{item.name}</span>
              </Link>
              )
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default DropdownMenu;
